import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {
    RiReplyLine, RiFileCopyLine, RiShareForwardLine, RiPushpinLine,
    RiStarLine, RiCheckboxLine, RiFlagLine, RiDeleteBinLine,
} from "react-icons/ri";
import {Menu, Item, Icon} from "./styles";

const MENU_W = 190;
const MENU_H = 320; // ~8 itens; usado só pra não estourar a borda de baixo

/**
 * Menu de contexto da mensagem. position:fixed ancorado ao gatilho (não é cortado
 * pelo overflow da conversa). Só Pin e Copy ativos; os outros 6 desabilitados.
 */
const MessageMenu = ({anchorRect, onClose, onPin, onCopy}) => {
    const {t} = useTranslation();
    const ref = React.useRef(null);

    React.useEffect(() => {
        const onDown = (e) => {
            if (ref.current && !ref.current.contains(e.target)) onClose();
        };
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("mousedown", onDown);
        document.addEventListener("keydown", onKey);
        return () => {
            document.removeEventListener("mousedown", onDown);
            document.removeEventListener("keydown", onKey);
        };
    }, [onClose]);

    // clampa dentro da janela: não passa da borda direita nem da de baixo.
    const left = Math.max(8, Math.min(anchorRect.left, window.innerWidth - MENU_W - 8));
    const top = Math.max(8, Math.min(anchorRect.bottom + 4, window.innerHeight - MENU_H - 8));

    return (
        <Menu ref={ref} style={{top, left, width: MENU_W}} role="menu">
            <Item disabled><Icon><RiReplyLine/></Icon> {t("words.reply")}</Item>
            <Item onClick={() => { onCopy(); onClose(); }}><Icon><RiFileCopyLine/></Icon> {t("words.copy")}</Item>
            <Item disabled><Icon><RiShareForwardLine/></Icon> {t("words.forward")}</Item>
            <Item onClick={() => { onPin(); onClose(); }}><Icon><RiPushpinLine/></Icon> {t("words.pin")}</Item>
            <Item disabled><Icon><RiStarLine/></Icon> {t("words.star")}</Item>
            <Item disabled><Icon><RiCheckboxLine/></Icon> {t("words.select")}</Item>
            <Item disabled><Icon><RiFlagLine/></Icon> {t("words.report")}</Item>
            <Item disabled><Icon><RiDeleteBinLine/></Icon> {t("words.delete")}</Item>
        </Menu>
    );
};

MessageMenu.propTypes = {
    anchorRect: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onPin: PropTypes.func.isRequired,
    onCopy: PropTypes.func.isRequired,
};

export default MessageMenu;
